import * as React from 'react'
import * as Dialog from 'primitives/dialog'
import { closeAidaMediaLightbox, isAidaCloseSuppressed, suppressAidaClose } from '../lightbox/store'
import type { AidaOverlayOrigin } from '../../stores/overlay-store'
import { isNestedLayerEvent } from '../../utils/overlay/nested-layer-event'
import { AidaFullscreenPanel } from './fullscreen-panel'
import { AidaOpenShell } from './open-shell'

function ignoreOutsideDismiss(event: {
  preventDefault: () => void
  target: EventTarget | null
  detail?: { originalEvent?: Event }
}) {
  event.preventDefault()
  if (isAidaCloseSuppressed() || isNestedLayerEvent(event)) {
    suppressAidaClose()
  }
}

export function AidaFullscreenDialog({
  open,
  onClose,
  origin,
  showShell,
  shellRef,
  fadeScrim,
  setFullscreenSlot,
  portalContainerRef,
}: {
  open: boolean
  onClose: () => void
  origin: AidaOverlayOrigin | null
  showShell: boolean
  shellRef: (node: HTMLDivElement | null) => void
  fadeScrim: (node: HTMLDivElement | null) => void
  setFullscreenSlot: (node: HTMLDivElement | null) => void
  portalContainerRef: React.RefObject<HTMLDivElement | null>
}) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={next => {
        if (!next) {
          if (isAidaCloseSuppressed()) {
            closeAidaMediaLightbox()
            return
          }
          onClose()
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay
          ref={fadeScrim}
          className="fixed inset-0 bg-theme_semantic_surface_scrim_overlay_fullscreen"
          onClick={event => {
            if (event.target !== event.currentTarget) {
              return
            }
            if (isAidaCloseSuppressed()) {
              closeAidaMediaLightbox()
              return
            }
            onClose()
          }}
        />
        <Dialog.Content
          asChild
          aria-describedby={undefined}
          onEscapeKeyDown={event => {
            if (isAidaCloseSuppressed()) {
              event.preventDefault()
              closeAidaMediaLightbox()
            }
          }}
          onInteractOutside={ignoreOutsideDismiss}
          onPointerDownOutside={ignoreOutsideDismiss}
          onFocusOutside={event => event.preventDefault()}
        >
          <AidaFullscreenPanel
            showShell={showShell}
            setFullscreenSlot={setFullscreenSlot}
            portalContainerRef={portalContainerRef}
          />
        </Dialog.Content>
        {showShell && origin ? <AidaOpenShell origin={origin} shellRef={shellRef} /> : null}
      </Dialog.Portal>
    </Dialog.Root>
  )
}
